import { isAllowedClerkReturnTo } from "./is-allowed-clerk-return-to"

/**
 * Resolve where to send the user after sign-in completes on the primary
 * domain, when they arrived from a satellite domain.
 *
 * Two param vocabularies arrive here:
 * - `return_to` — our own param, set by *.seam.vc satellites bouncing to
 *   the primary for auth.
 * - `redirect_url` / `sign_in_force_redirect_url` — Clerk's params, set by
 *   clerk-js buildSignInUrl() on satellite pages (e.g. the Ring account-link
 *   page on connect.getseam.com). The value already carries Clerk's
 *   __clerk_synced sync trigger, so redirecting straight back lets the
 *   satellite finish its session sync instead of looping. NOTE: clerk-js
 *   appends these AFTER the hash (`/signin#/?redirect_url=...`) because our
 *   <SignIn> is hash-routed — callers must merge in getClerkHashParams()
 *   output, since router.query cannot see them.
 *
 * Clerk's own <SignIn> component honors `redirect_url` after a fresh
 * sign-in, but when the user is already signed in our custom
 * <SignedIn> redirect runs instead — so it must honor the param too,
 * or satellite flows strand the user on the console homepage.
 *
 * Returns null unless the value passes the satellite allowlist.
 */
export const getSigninReturnTo = (
  query: Record<string, string | string[] | undefined>
): string | null => {
  for (const key of [
    "return_to",
    "sign_in_force_redirect_url",
    "redirect_url",
  ]) {
    const value = query[key]
    if (typeof value === "string" && isAllowedClerkReturnTo(value)) {
      return value
    }
  }
  return null
}
